// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog___1JnNi","blog__container":"blog__container____ADNr","blog__logo":"blog__logo___iQvRc","blog__name":"blog__name___3jM09","blog__description":"blog__description___1hp9u","blog__header":"blog__header___rUvjv"};
    if(module.hot) {
      // 1677682838068
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  